"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingAcquisitionMethod = void 0;
var AccountingAcquisitionMethod;
(function (AccountingAcquisitionMethod) {
    AccountingAcquisitionMethod["INTUIT"] = "INTUIT";
    AccountingAcquisitionMethod["MERGE_DEV"] = "MERGE_DEV";
    AccountingAcquisitionMethod["FILE"] = "FILE";
    AccountingAcquisitionMethod["MANUAL"] = "MANUAL";
})(AccountingAcquisitionMethod || (exports.AccountingAcquisitionMethod = AccountingAcquisitionMethod = {}));
